import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { DeviceList } from '../gateway.model';
import { GateWayDeviceActionTypes, GateWayDeviceActions } from '../actions/gateway-device.actions';


export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: []
};
export interface GateWayResultAddToCloudState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialResultAddToCloudState: GateWayResultAddToCloudState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: GateWayDeviceActions
): State {
  switch (action.type) {

    case GateWayDeviceActionTypes.UpsertGatewayDeviceList: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case GateWayDeviceActionTypes.ReadGatewayDeviceList: {
      return {...state, Loaded: false, Loading: true, entities: action.payload};
    }

    case GateWayDeviceActionTypes.ReadGatewayDeviceListFail: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}

export function addToCloudReducer(
  state = initialResultAddToCloudState,
  action: GateWayDeviceActions
): GateWayResultAddToCloudState {
  switch (action.type) {

    case GateWayDeviceActionTypes.AddDeviceToCloud: {
      return {...state, Loaded: false, Loading: true};
    }

    case GateWayDeviceActionTypes.ResultAddDeviceToCloud: {
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    default: {
      return state;
    }
  }
}

export const getGateWayDeviceListState = (state: State) => state;
export const getGateWayResultAddToCloudState = (state: GateWayResultAddToCloudState) => state;

